<template>
  <main id="content" class="layout-content">
    <div class="container">
      <router-link to="/" class="back-link font-bold font-bai">{{$t('app.Accueil')}}</router-link>
      <div class="c404-500 text-center font-bai">
        <h1 v-html="$t('app.500 - Internal Server Error')"></h1>
        <img class="i404-500" src="../assets/images/500.svg" alt="404" />
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Error500Page"
};
</script>
